// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__eBsP7","footer":"ModalInfo_footer__p7h4y"};